import React from "react";
import { Link } from "react-router-dom";
import { FaInstagram, FaTwitter, FaFacebook } from "react-icons/fa";

const Footer = () => {
  return (
    <footer
      style={{
        background: "linear-gradient(135deg, #0f0f0f 0%, #1a0f00 100%)",
        borderTop: "2px solid #FF7618",
        color: "#d4d4d4",
        padding: "40px 0 20px",
      }}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="md:col-span-2">
            <Link
              to="/"
              style={{
                display: "flex",
                alignItems: "center",
                gap: "10px",
                marginBottom: "12px",
                textDecoration: "none",
              }}
              className="hover:scale-105 transition-all duration-500 -mt-8 max-w-28"
            >
              <img
                src="/images/mech_now.webp"
                alt="Mech Now"
                className="w-24"
              />
            </Link>
            <p
              style={{
                color: "#888",
                fontSize: "14px",
                maxWidth: "320px",
                lineHeight: 1.7,
              }}
            >
              India's leading machinery rental platform. Connecting construction
              professionals with quality equipment from verified vendors across
              Madhya Pradesh.
            </p>
            <div style={{ display: "flex", gap: "10px", marginTop: "16px" }}>
              <a
                href="https://www.instagram.com/mech_now?igsi=MWd3MWJsdnFmdzl6Yg=="
                target="__blank"
                className="hover:text-orange-500 transition-all duration-500 ease-in-out"
              >
                <FaInstagram size={20} />
              </a>
              {/* <a href="https://instagram.com">
                <FaTwitter size={20} />
              </a>
              <a href="https://instagram.com">
                <FaFacebook size={20} />
              </a> */}
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3
              style={{
                color: "#fbbf24",
                fontWeight: 700,
                marginBottom: "16px",
                fontSize: "15px",
              }}
            >
              Quick Links
            </h3>
            <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
              {[
                { to: "/machines", label: "Browse Machines" },
                { to: "/vendor/register", label: "Become a Vendor" },
                { to: "/about", label: "About Us" },
                { to: "/contact", label: "Contact" },
              ].map((link) => (
                <li key={link.to} style={{ marginBottom: "8px" }}>
                  <Link
                    to={link.to}
                    style={{
                      color: "#888",
                      textDecoration: "none",
                      fontSize: "14px",
                      transition: "color 0.2s",
                    }}
                    onMouseEnter={(e) => (e.target.style.color = "#FF7618")}
                    onMouseLeave={(e) => (e.target.style.color = "#888")}
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Support */}
          <div>
            <h3
              style={{
                color: "#fbbf24",
                fontWeight: 700,
                marginBottom: "16px",
                fontSize: "15px",
              }}
            >
              Support
            </h3>
            <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
              {[
                { to: "/help", label: "Help Center" },
                { to: "/terms", label: "Terms of Service" },
                { to: "/privacy", label: "Privacy Policy" },
              ].map((link) => (
                <li key={link.to} style={{ marginBottom: "8px" }}>
                  <Link
                    to={link.to}
                    style={{
                      color: "#888",
                      textDecoration: "none",
                      fontSize: "14px",
                      transition: "color 0.2s",
                    }}
                    onMouseEnter={(e) => (e.target.style.color = "#FF7618")}
                    onMouseLeave={(e) => (e.target.style.color = "#888")}
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
              <li style={{ marginBottom: "8px" }}>
                <a
                  href="mailto:support@mechnow.com"
                  style={{
                    color: "#888",
                    textDecoration: "none",
                    fontSize: "14px",
                  }}
                  onMouseEnter={(e) => (e.target.style.color = "#FF7618")}
                  onMouseLeave={(e) => (e.target.style.color = "#888")}
                >
                  support@mechnow.com
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div
          style={{
            borderTop: "1px solid #222",
            marginTop: "32px",
            paddingTop: "20px",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            flexWrap: "wrap",
            gap: "8px",
          }}
        >
          <p style={{ color: "#555", fontSize: "13px" }}>
            © {new Date().getFullYear()} MechNow. All rights reserved.
          </p>
          <p style={{ color: "#555", fontSize: "13px" }}>
            Made with ❤️ in India
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
